import { ReactSVG } from 'react-svg';

function BBOWBackground() {
  return <ReactSVG src="/assets/FooterBackground.svg" />;
}

export default BBOWBackground;
